/* @flow */

import type { Reducer } from 'redux';

export type ExamineeProfile = {
  +avatar: string,
  +nickname: ?string,
};

// Actions

const UPDATE_PROFILE_SUCCESS: 'proc/profile/UPDATE_PROFILE_SUCCESS' = 'proc/profile/UPDATE_PROFILE_SUCCESS';
const LOAD_PROFILE_SUCCESS: 'proc/profile/LOAD_PROFILE_SUCCESS' = 'proc/profile/LOAD_PROFILE_SUCCESS';

type UpdateProfileSuccessActionType = $Call<typeof updateProfileSuccess, *>;
type LoadProfileSuccessActionType = $Call<typeof loadProfileSuccess, *>;
export type ProfileActionType = UpdateProfileSuccessActionType | LoadProfileSuccessActionType;

// Reducer

const reducer: Reducer<?ExamineeProfile, ProfileActionType> = (state = null, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_SUCCESS:
    case LOAD_PROFILE_SUCCESS:
      return action.payload;
    default:
      (action: empty);
      return state;
  }
};
export default reducer;

// Action creators

export const updateProfileSuccess = (payload: ?ExamineeProfile) => {
  return { type: UPDATE_PROFILE_SUCCESS, payload };
};

export const loadProfileSuccess = (payload: ?ExamineeProfile) => {
  return { type: LOAD_PROFILE_SUCCESS, payload };
};
